<template>
  <div class="account u-overlay u-row u-center u-middle u-column u-pad-y-md u-overflow-y-scroll">
    <div class="u-relative u-w3of12 u-w6of12--md u-w11of12--sm">
      <div class="u-flex u-center">
        <app-account-info
          :isFull="false"
          :firstName="firstName"
          :lastName="lastName"
          :company="company"
          :role="role"
          :email="email"
          :picture="picture"
          @change="onUpdateFields"
        />
      </div>
      <div class="account__action u-flex u-center u-white u-marg-t-lg">
        <app-button :hasGradientBorder="true" @click="$router.push($local('city'))">{{$t('button.cancel')}}</app-button>
        <app-button :hasGradient="true" class="u-marg-l-sm" @click="onSave">{{$t('button.save')}}</app-button>
      </div>
    </div>
  </div>
</template>

<script>
import { VirtualScroll } from '@/utils/VirtualScroll'
import { webGL } from '@/webGL/WebGL'

import gsap from 'gsap'

import AppAccountInfo from '@/components/AppAccountInfo'
import Account from '@/components/Account'

export default {
  mixins: [
    Account
  ],
  components: {
    AppAccountInfo
  },
  methods: {
    async onSave () {
      this.$store.dispatch('user/update', this.fields).then(() => {
        this.$router.push({...this.$local('avatar')})
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
// @import '~@/styles/settings/variables'
</style>
